import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import GalleryEdit from "./Components/GalleryEdit";
import Loader from "./Components/Loader";

const GalleryEditPage=()=>{

    useEffect(()=>{
        document.title="Edit Gallery | Janushree"
      },[]);
      
    return(
        <>
            <Header/>
            <GalleryEdit/>
            <Loader/>
            <Footer/>
        </>
    );
}

export default GalleryEditPage;